import { queryCache, useMutation } from "react-query-legacy";
import { BillingEngineService } from "services";
import { manualStockEntryQueryKey } from "./useQueryStockEntries";

function useQueryUpdateStockEntries() {
  return useMutation(BillingEngineService.updateStockEntries, {
    onSuccess: () => {
      queryCache.refetchQueries(manualStockEntryQueryKey);
    },
  });
}

export default useQueryUpdateStockEntries;
